/* eslint-disable import/prefer-default-export */
export function getSprintUserStorySummary(sprint) {
  if (!sprint?.user_stories?.length) {
    return '';
  }
  return sprint.user_stories
    .map((userStory) => `${userStory.title} ${userStory.price} EUR + PVM`)
    .join('\n');
}
